import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { Modal, Button, MenuItem } from 'react-bootstrap';

import AlertIcon from '../alert-icon';
import ProgressBar from '../progress-bar';
// Import Actions
import { requestSyncTruVoice } from '../../modules/Admin/AdminActions';

// Import Selectors
import { getUser } from '../../modules/Auth/AuthReducer';

class TruVoiceResync extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      done: false,
      show: false,
      errors: null,
    };
    this.syncRequest = this.syncRequest.bind(this);
    this.done = this.done.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  syncRequest() {
    this.setState({ loading: true, done: false, errors: null });
    this.props.dispatch(requestSyncTruVoice())
      .then(
        () => {
          this.setState({
            loading: false, done: true, show: true, errors: null,
          });
        },
        (errors) => {
          if (this.mounted) {
            this.setState({ loading: false, done: false, errors: errors.data || errors });
          }
        },
      );
  }

  done() {
    this.setState({ show: false, done: false });
  }


  handleClick(e) {
    const { isInitial, disabled } = this.props;
    e.preventDefault();
    if (disabled) {
      return;
    }
    this.setState({ show: true, errors: null });
    if (isInitial) {
      this.syncRequest();
    }
  }
  renderModal() {
    const {
      loading, show, done, errors,
    } = this.state;
    const { user } = this.props;
    if (!user._id) {
      return;
    }
    const size = done ? 'sm' : null;
    return (
      <Modal show={show} bsSize={size} onHide={this.done}>
        <Modal.Header>
          Refresh All TruVoice Data
        </Modal.Header>
        {!done &&
          <div>
            <Modal.Body>
              {!loading &&
                <div>
                  {errors === null &&
                    <div>
                      <p>
                        Are you sure you want to refresh all TruVoice data?
                      </p>
                      <p>
                        Refreshing the database can take a few minutes. Thank you for your patience.
                      </p>
                    </div>
                  }
                  {errors !== null && errors.message !== null &&
                    <p className="text-danger">
                      &nbsp;<br />{errors.message}
                    </p>
                  }
                </div>
              }
              {loading &&
                <div>
                  <p>One moment please... this may take awhile...</p>
                  <ProgressBar />
                </div>
              }
            </Modal.Body>
            <Modal.Footer>
              <div className="row">
                <div className="col-xs-6">
                  <div className="clearfix">
                    <Button className="pull-left" disabled={loading} bsStyle="link" onClick={this.done}>Cancel</Button>
                  </div>
                </div>
                <div className="col-xs-6">
                  <div className="clearfix">
                    <Button className="pull-right" disabled={loading} bsStyle="primary" onClick={this.syncRequest}>Yes - Refresh TruVoice Data</Button>
                  </div>
                </div>
              </div>
            </Modal.Footer>
          </div>
        }

        {done &&
          <div>
            <Modal.Body>
              <AlertIcon />
              <div className="text-center">
                <h4>Success</h4>
                <p>All TruVoice data has been synced.</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button bsSize="large" bsStyle="primary" block onClick={this.done}>OK</Button>
            </Modal.Footer>
          </div>
        }
      </Modal>
    );
  }
  render() {
    const {
      btnTitle, isMenu, className, disabled, user,
    } = this.props;
    const { loading } = this.state;
    if (!user._id || user.role !== 'superadmin') {
      return null;
    }
    if (isMenu) {
      return (
        <MenuItem disabled={disabled} onClick={(e) => { this.handleClick(e); }}>
          <Fa name="refresh" /> {btnTitle}
          {this.renderModal()}
        </MenuItem>
      );
    }
    return (
      <span>
        <button disabled={disabled || loading} className={className} onClick={(e) => { this.handleClick(e); }}>
          {loading && <Fa name="refresh" spin />}
          {!loading && <Fa name="refresh" />}
          &nbsp;
          {btnTitle}
        </button>
        {this.renderModal()}
      </span>
    );
  }
}

TruVoiceResync.propTypes = {
  dispatch: PropTypes.func.isRequired,
  btnTitle: PropTypes.string,
  user: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  isMenu: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isInitial: PropTypes.bool,
};
TruVoiceResync.defaultProps = {
  btnTitle: 'Refresh TruVoice Data',
  isMenu: false,
  disabled: false,
  isInitial: false,
  className: 'btn btn-primary',
};
// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}
export default connect(mapStateToProps)(TruVoiceResync);
